import React, { useContext } from "react";
import OurTeamCard from "../ourteamCard";
import ourteamstyles from "./ourteam.module.css";
import { LanguageContext } from "../../context/LanguageContext";

function OurTeam() {
  const { data } = useContext(LanguageContext);

  // console.log({Data});
  const Data = data.ourTeam;

  return (
    <div id="OurTeam" className="mainWrap">
      <div className={ourteamstyles.ourTeam}>
        <h2 className="mainHeading">{Data.title}</h2>
        <p className="subHeading">{Data.subtitle}</p>

        <div>
          <p className={ourteamstyles.ourteamDescription}>{Data.p1}</p>
          <p className={ourteamstyles.ourteamDescription}>{Data.p2}</p>
        </div>
      </div>

      <div className={ourteamstyles.ourteamMatesWrap}>
        {Data.team &&
          Data.team.length > 0 &&
          Data.team.map((item, index) => (
            <OurTeamCard
              key={index}
              imagesrc={item.imagesrc}
              name={item.name}
              title={item.title}
            />
          ))}
      </div>
    </div>
  );
}

export default OurTeam;
